import { api } from '../api/client';
import { useAuth } from './store';

/** Ends the admin session on the server, then forgets it here. The local
 *  sign-out happens even if the server call fails (network down, session
 *  already expired) — the token then simply runs out at its expiry. */
export async function signOut(): Promise<void> {
  if (useAuth.getState().token) {
    try {
      await api.post('/admin/auth/logout');
    } catch {
      /* signed out locally below either way */
    }
  }
  useAuth.getState().logout();
}
